export const INVITED = "INVITED";
export const SIGNED_UP = "SIGNED UP";
export const SUBSCRIBED = "SUBSCRIBED";
export const PENDING = "PENDING";
export const SENT = "SENT";
export const FIRST_TASK_PAID = "FIRST TASK PAID";
export const NEW_GROUP_CREATED = "NEW GROUP CREATED";
export const GROUP_ALREADY_CREATED = "GROUP ALREADY CREATED";
